<template>
 <v-container class="modal-container" data-app>
   <v-dialog
     v-model="modalVisible"
     persistent
     max-width="600px"
   >
     <template v-slot:activator="{ on, attrs }">
       <v-btn
         v-if="logged"
         icon
         color="blue"
         dark
         v-bind="attrs"
         v-on="on"
       >
         <v-icon>
           mdi-eye-plus
         </v-icon>
       </v-btn>
       <v-btn
         v-else
         icon
         @click="notLoggedSnackBar()"
       >
         <v-icon>
           mdi-eye-plus
         </v-icon>
       </v-btn>
     </template>
     <v-card>
       <v-card-title class="title"> How was it as at {{ restaurantName }} </v-card-title>
       <v-card-text>
         <v-form ref="form" class="form-visit">
           <v-menu
             ref="refDate"
             v-model="form.menuDate"
             :close-on-content-click="false"
             :return-value.sync="form.date"
             transition="scale-transition"
             offset-y
             min-width="auto"
           >
             <template v-slot:activator="{ on, attrs }">
               <v-text-field
                 v-model="form.date"
                 :rules="pickerRules"
                 label="Date"
                 prepend-icon="mdi-calendar"
                 readonly
                 outlined
                 required
                 v-bind="attrs"
                 v-on="on"
               ></v-text-field>
             </template>
             <v-date-picker
               v-model="form.date"
               no-title
               scrollable
               required
               :max="todayDate"
             >
               <v-spacer></v-spacer>
               <v-btn
                 text
                 color="primary"
                 @click="form.menuDate = false"
               >
                 Cancel
               </v-btn>
               <v-btn
                 text
                 color="primary"
                 @click="$refs.refDate.save(form.date)"
               >
                 OK
               </v-btn>
             </v-date-picker>
           </v-menu>


           <v-menu
             ref="refTime"
             v-model="form.menuTime"
             :close-on-content-click="false"
             :nudge-right="40"
             :return-value.sync="form.time"
             transition="scale-transition"
             offset-y
             max-width="290px"
             min-width="290px"
           >
             <template v-slot:activator="{ on, attrs }">
               <v-text-field
                 v-model="form.time"
                 :rules="pickerRules"
                 label="Time"
                 prepend-icon="mdi-clock-time-four-outline"
                 readonly
                 v-bind="attrs"
                 v-on="on"
               ></v-text-field>
             </template>
             <v-time-picker
               v-if="form.menuTime"
               v-model="form.time"
               full-width
               use-seconds
               @click:second="$refs.refTime.save(form.time)"
             ></v-time-picker>
           </v-menu>
           <v-rating
             class="ml-7"
             dense
             half-increments
             v-model="form.rating"
             background-color="orange lighten-3"
             color="orange"
             medium
             icon-label="custom icon label text {0} of {1}"
           ></v-rating>
           <v-textarea
             class="mt-6"
             label="Comments"
             outlined
             :rules="textareaRules"
             v-model="form.comment"
             prepend-icon="mdi-lead-pencil" ></v-textarea>
           <v-btn class="ma-2" @click="clearForm()">
             Cancel
           </v-btn>
           <v-btn class="success-btn ml-2" color="primary" @click="submitForm()">Confirm</v-btn>
         </v-form>
       </v-card-text>
     </v-card>
   </v-dialog>
   <v-snackbar
     v-model="snackbar"
     :timeout="2000"
     top
     right
     :multi-line="snackbarAtt"
     color="success"
   >
     {{ snackbarText }}

     <template v-slot:action="{ attrs }">
       <v-btn
         class="mr-3"
         icon
         color="black"
         text
         v-bind="attrs"
         @click="snackbar = false"
       >
         Close
       </v-btn>
     </template>
   </v-snackbar>
   <v-snackbar
     v-model="snackbarNotLoggeed"
     :timeout="3500"
     bottom
     :multi-line="snackbarAttNotLoggeed"
   >
     {{ snackbarTextNotLoggeed }}

     <template v-slot:action="{ attrs }">
       <v-btn
         class="mr-3"
         icon
         color="red"
         text
         v-bind="attrs"
         @click="snackbarNotLoggeed = false"
       >
         Close
       </v-btn>
     </template>
   </v-snackbar>
 </v-container>
</template>

<script>
import user from "../../services/user/user"

export default {
  name: "modal-visit",

  props: ["restaurantName", "modalVisible", "restaurantId","logged",'userToken'],

  data: () => ({
    form : {
      date : null,
      menuDate : false,
      time : null,
      menuTime : false,
      rating : 1,
      comment : "",
      menu2 : false,
    },
    todayDate : '',
    snackbar : false,
    snackbarNotLoggeed : false,
    snackbarText : "",
    snackbarTextNotLoggeed : "",
    snackbarAtt : true,
    snackbarAttNotLogged : true,
    textareaRules: [
      v => v.length < 250 || "Comments have a limit of 250 Characters",
      v => !!v || "This field is required"
    ],
    pickerRules:[
      v => !!v || "This field is required"
    ]
  }),

   created () {
    this.setTodayDate()
  },

  methods: {
    async submitForm() {
      if (this.$refs.form.validate()) {
        const token = {
          restaurant_id : this.restaurantId,
          comment : this.form.comment,
          rating : this.form.rating,
          date : `${this.form.date}T${this.form.time}Z`
        };
        try {
          await user.postUserVisit(token,this.userToken.id);
          this.clearForm();
          this.snackbar = true;
          this.snackbarText = "Visit Review added to restaurant";
        } catch (err) {
          this.snackbar = true;
          this.snackbarText = err
        }

      }
    },

    cancelForm() {
      this.clearForm()
    },

    clearForm() {
      this.modalVisible = false;
      this.form.comment = "";
      this.form.date = null;
      this.form.time = null;
      this.form.rating = 1;
    },

    setTodayDate() {
      var d = new Date();
      let month = '' + (d.getMonth() + 1);
      let day = '' + d.getDate();
      let year = d.getFullYear();

      if (month.length < 2)
        month = '0' + month;
      if (day.length < 2)
        day = '0' + day;

      this.todayDate = [year, month, day].join('-')
    },

    notLoggedSnackBar() {
      this.snackbarNotLoggeed = true
      this.snackbarTextNotLoggeed = "You have to be logged in to use that function"
    }

  }
}

</script>

<style scoped>

</style>
